//@ts-ignore
import { tw } from "@careinfo/tailwind";
import useGetHook from "../hooks/useGetHook";
import APIS from "../constant/Endpoint";
import usePatchHook from "../hooks/usePatchHook";

const AccountSwitcher = ({accounts, isLoading}) => {


  const { mutateAsync, isLoading: isPostLoading } = usePatchHook({
    queryKey: ["users-accounts"],
    navigateURL: "",
  });

  const handleToggle = async (id: string, isActive: boolean) => {
    const url = `${APIS.ACCOUNTS}${id}/`;
    const formData = { is_active: isActive };

    try {
      await mutateAsync({
        url,
        formData,
        setError: () => {},
      });
    } catch (err) {
      console.log(err);
    }
  };

  if (isLoading) return <p>Loading accounts...</p>;

  return (
    <div className={tw`w-[500px] bg-white rounded-xl p-2 flex flex-col gap-2`}>
      {accounts?.map((account: any) => (
        <div
          key={account.id}
          onClick={() => handleToggle(account.id, !account.is_active)}
          className={tw`
            flex items-center gap-3 p-3 rounded-lg border cursor-pointer
            hover:bg-gray-100 transition
          `}
        >
          <div
            className={tw`
              h-10 w-10 rounded-full flex items-center justify-center
              text-white font-semibold uppercase
              ${account.is_active ? "bg-primary" : "bg-gray-400"}
            `}
          >
            {account.full_name?.charAt(0)}
          </div>

          <div className={tw`flex flex-col`}>
            <span className={tw`text-sm font-medium`}>{account.full_name}</span>
            <span className={tw`text-xs text-gray-500`}>
              @{account.username}
            </span>
          </div>

          {account.is_active && (
            <span className={tw`ml-auto text-xs text-blue-600 font-semibold`}>
              Active
            </span>
          )}
        </div>
      ))}
    </div>
  );
};

export default AccountSwitcher;
